/**
 * @flow
 */

import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

import { Modal, Button, Color } from '../../../../../components';
import ServiceForm from './ServiceForm';

import type { ModalDialog, ReduxForm, Service } from '../../../../../type';

type EditServiceDialogProps = {
    service: Service,
    languages: Array<string>,
    defaultLanguage: string,
} & ModalDialog &
    ReduxForm;

const EditServiceDialog = ({
    trigger,
    open,
    onClose,
    submitting,
    pristine,
    error,
    handleSubmit,
    service,
    languages,
    defaultLanguage,
}: EditServiceDialogProps) => (
    <Modal size="small" trigger={trigger} open={open} onClose={onClose}>
        <Modal.Header>
            <Color size={48} color={service.color} spaced="right" />
            {service.name}
        </Modal.Header>
        <Modal.Content>
            {error && (
                <Message error>
                    <Icon name="warning sign" />
                    {error}
                </Message>
            )}
            <ServiceForm
                handleSubmit={handleSubmit}
                languages={languages}
                defaultLanguage={defaultLanguage}
            />
        </Modal.Content>
        <Modal.Actions>
            <Button
                disabled={submitting || pristine}
                loading={submitting}
                onClick={handleSubmit}
                primary
            >
                <Icon name="checkmark" />
                <FormattedMessage
                    id="pages.settings.services.edit.save"
                    defaultMessage="Save"
                />
            </Button>
            <Button disabled={submitting} onClick={onClose} basic>
                <Icon name="remove" />
                <FormattedMessage
                    id="pages.settings.services.edit.cancel"
                    defaultMessage="Cancel"
                />
            </Button>
        </Modal.Actions>
    </Modal>
);

export default EditServiceDialog;
